import React, { useEffect } from 'react';
import Layout from '../components/Layout';
import { Box } from '@mui/material';
import Service from '../components/Service';
import { useTour } from '../provider/TourGuide';
import introJs from 'intro.js';
import { ServicePage as Tour } from '../enums/tourEnums';

const ServicePage = () => {
    const {SaveRead, onExitService,setEnableService,enableService} = useTour()

    useEffect(() => {
        if(!localStorage.getItem("service")){
          const intro = introJs()
            .onstart(() => setEnableService(true))
            .oncomplete(() => onExitService())
            .onexit(() => onExitService());
            intro.setOptions({
                ...Tour,
                scrollToElement: false,     
                disableInteraction: true,  
            });
          intro.start();
        }
    },[SaveRead])
    
    return (
        <Layout>
            <Box>
                <Service.Filter/>
                <Service.LastOrders/>
                <Service.List/>
            </Box>
        </Layout>
    );
};

export default ServicePage;